import { Pipe, PipeTransform } from '@angular/core';

import { NgSelectModel } from '../../shared/models/ng-select.model';

@Pipe({
    name: 'mapToNgSelectList',
    standalone: false
})
export class MapToNgSelectListPipe implements PipeTransform {
  transform(values: string[]): NgSelectModel[] {
    return values?.map(value => {
      return {
        value,
        disabled: false
      }
    });
  }
}
